class ProductCardQuickAdd extends Theme.Component {
  connectedCallback() {
    this.events();
    this.form = this.querySelector("form");
    this.modal = this.querySelector(".quickadd-modal");

    this._handleOutside = this.handleOutside.bind(this);
    document.addEventListener("pointerdown", this._handleOutside);
  }

  disconnectedCallback() {
    document.removeEventListener("pointerdown", this._handleOutside);
  }

  singleQuickAdd(_, element) {
    const input = element.querySelector("input[data-variant-id]");
    if (!input) return;
    this.addToCart(input.dataset.variantId);
  }

  toggleQuickAdd() {
    if (!this.modal) return;
    this.modal.classList.toggle("is-open");
  }

  variantQuickAdd(_, element) {
    const input = element.querySelector("input[data-variant-id]");
    if (!input) return;
    this.addToCart(input.dataset.variantId);
  }

  handleOutside(event) {
    if (!this.modal) return;
    if (!this.modal.classList.contains("is-open")) return;

    const content = this.modal.querySelector(".quickadd-modal-content");
    const toggle = this.querySelector(".quickadd-toggle");

    if (
      (content && content.contains(event.target)) ||
      (toggle && toggle.contains(event.target))
    )
      return;

    this.modal.classList.remove("is-open");
  }

  addToCart(variantId) {
    if (!variantId || !this.form) return;
    const data = new FormData(this.form);
    data.set("id", variantId);

    fetch("/cart/add.js", {
      method: "POST",
      body: data,
    })
      .then((res) => res.json())
      .then((response) => {
        document.dispatchEvent(
          new CustomEvent("addtocart", { detail: response })
        );
      })
      .catch((error) => {
        console.error("ProductCardQuickAdd: add to cart failed", error);
      });
  }
}

customElements.define("product-card-quickadd", ProductCardQuickAdd);

class UpsellQuickAdd extends Theme.Component {
  connectedCallback() {
    this.events();
    this.form = this.querySelector("form");
    this.container = this.querySelector(
      ".upsell-quickadd:not(.visibility--none)"
    );
    this.modal = this.querySelector(".upsell-quickadd-modal");

    this._handleOutside = this.handleOutside.bind(this);
    document.addEventListener("pointerdown", this._handleOutside);
  }

  disconnectedCallback() {
    document.removeEventListener("pointerdown", this._handleOutside);
  }

  openQuickAdd() {
    const others = document.querySelectorAll(
      "upsell-quick-add .upsell-quickadd.is-open"
    );

    others.forEach((item) => {
      if (item !== this.container) {
        item.classList.remove("is-open");
      }
    });

    this.container.classList.add("is-open");
  }

  toggleQuickAdd() {
    if (!this.modal) return;
    this.container.classList.toggle("is-open");
  }

  addToCart(variantId) {
    console.log("UpsellQuickAdd: addToCart called", variantId);
    if (!variantId) return;

    const data = new FormData();
    data.set("id", variantId);

    fetch("/cart/add.js", {
      method: "POST",
      body: data,
    })
      .then((res) => res.json())
      .then((response) => {
        console.log("UpsellQuickAdd: added to cart", response);
        document.dispatchEvent(
          new CustomEvent("addtocart", { detail: response })
        );
      })
      .catch((error) => {
        console.error("UpsellQuickAdd: add to cart failed", error);
      });
  }

  addVariant(_, element) {
    const variantId = element.dataset.variantId;
    if (!variantId) return;
    this.addToCart(variantId);
  }

  quickAddTrigger() {
    this.toggleQuickAdd();
  }


  handleOutside(event) {
    if (!this.container) return;
    if (!this.container.classList.contains("is-open")) return;

    const clickedInsideModal = event.target.closest(".upsell-quickadd-modal");
    const clickedTrigger = event.target.closest(".upsell-quickadd-trigger");

    if (clickedInsideModal) return;
    if (clickedTrigger) return;

    this.container.classList.remove("is-open");
  }
}

customElements.define("upsell-quick-add", UpsellQuickAdd);

